import { useState, useEffect } from "react";
import { processText } from "../../../utils/learnUtils";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateProgressFeedback } from "../../../actions/progress";

const RATINGS = [
  {
    value: 1,
    emoji: "😔",
    label: "Hopeless!",
    desc: "Hopeless! I'm completely lost",
  },
  {
    value: 2,
    emoji: "🤔",
    label: "Challenging",
    desc: "Challenging. I understood some parts but not others",
  },
  {
    value: 3,
    emoji: "😐",
    label: "Okay",
    desc: "Okay. I'm hanging on in there",
  },
  { value: 4, emoji: "😊", label: "Good", desc: "Good. I'm doing fine" },
  {
    value: 5,
    emoji: "⭐",
    label: "Easy!",
    desc: "Easy! I understood everything",
  },
];

const DEFAULT_HINT = "Click one of the icons to provide feedback";

/**
 * Renders an EDCOMP_FEEDBACK content item.
 * Displays a compact inline comprehension check — dismissed on option selection or close.
 * @param {{ item: object }} props
 */
export default function FeedbackComp({ item, sectionId }) {
  const [dismissed, setDismissed] = useState(false);
  const [hoveredDesc, setHoveredDesc] = useState(null);
  const title = processText(item.title ?? "");
  const text = item.data?.text ?? "";

  // Get the post id from the URL
  const { id } = useParams();
  const dispatch = useDispatch();

  // Retrieve problems tried from reducer (includes notebooks)
  const feedback = useSelector((state) => state.ProgressReducer.feedback);
  useEffect(() => {
    const alreadyHaveFeedback = feedback
      ?.map((item) => {
        return String(item.sectionId);
      })
      .includes(String(sectionId));
    if (alreadyHaveFeedback) {
      setDismissed(true);
    }
  }, [feedback]);

  if (dismissed) return null;

  return (
    <div className="ct__feedback">
      <button
        className="ct__feedback-close"
        onClick={() => setDismissed(true)}
        aria-label="Dismiss feedback"
      >
        ×
      </button>
      <div className="ct__feedback-header">
        {title && (
          <span
            className="ct__feedback-title"
            dangerouslySetInnerHTML={{ __html: title }}
          />
        )}
        {text && <span className="ct__feedback-desc">{text}</span>}
      </div>
      <div className="ct__feedback-options">
        {RATINGS.map((r) => (
          <button
            key={r.value}
            className="ct__feedback-option"
            onClick={() => {
              dispatch(updateProgressFeedback(id, sectionId, r.value));
              setDismissed(true);
            }}
            onMouseEnter={() => setHoveredDesc(r.desc)}
            onMouseLeave={() => setHoveredDesc(null)}
            aria-label={r.desc}
          >
            <span className="ct__feedback-option-emoji">{r.emoji}</span>
            <span className="ct__feedback-option-label">{r.label}</span>
          </button>
        ))}
      </div>
      <p className="ct__feedback-hint">{hoveredDesc ?? DEFAULT_HINT}</p>
    </div>
  );
}
